export default __webpack_public_path__ + "hall-of-fame-desktop-d38a0dd603778a1dc3ccf883d814832b.png";